import { ViewportScroller } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: '',
  template: '',
})
export class FormsComponentComponent implements OnInit, AfterViewInit {
  form!: FormGroup;

  private _navClick!: number;
  get navClick() {
    return this._navClick;
  }
  @Input() set navClick(navClick: number | null) {
    let isScroll: boolean = typeof navClick === 'number' && !!navClick;
    if (typeof navClick === 'number') {
      this._navClick = navClick;
    }

    this.onSubmit(isScroll);
  }
  @Output() onDisableNavBtn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private scroller: ViewportScroller) {
    // this.navClick = 0;
  }

  ngOnInit(): void {
    this.scroller.scrollToPosition([0, 0]);
    this.checkValidForm();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(500), distinctUntilChanged(), untilDestroyed(this)).subscribe((value) => {
      this.checkValidForm();
    });
    this.form.markAsUntouched();
  }

  checkValidForm(): void {
    if (this.form.status === 'VALID') {
      this.onDisableNavBtn.emit(false);
    } else {
      this.onDisableNavBtn.emit(true);
    }
  }

  onSubmit(isScroll: boolean): void {
    if (this.form.valid) {
      this.onDisableNavBtn.emit(false);
    } else {
      this.form.markAllAsTouched();
      this.form.markAsTouched({ onlySelf: true });
      this.form.updateValueAndValidity();
      for (const key in this.form.controls) {
        if (this.form.controls[key].invalid) {
          if (isScroll) {
            this.scroller.scrollToAnchor(key);
            this.scroller.setOffset([0, 200]);
          }
          break;
        }
      }
    }
  }

  isInvalidDate(controlName: string) {
    const control = this.form.get(controlName);
    return this.form.errors?.['isAfterEnd'] && control?.touched;
  }

  isInvalid(controlName: string) {
    const control = this.form.get(controlName);

    return (control?.getError('required') || control?.getError('pattern')) && control?.touched; //!!Number(control?.value) ||;
  }

  isSoftValid(controlName: string) {
    const control = this.form.get(controlName);
    if (!this.form.touched) {
      return true;
    } else if (typeof control?.value === 'number') {
      return !!control?.value && control?.touched;
    } else if (typeof control?.value === 'boolean') {
      return control?.value && control?.touched;
    } else {
      return !!control?.value?.length && control?.touched;
    }
  }
}
